import React from 'react';
import Scroll from 'react-scroll';
import FormControl from 'react-bootstrap/FormControl';

import FieldCity from '../FieldCity';
import FieldState from '../FieldState';
import FieldCountry from '../FieldCountry';
import Display from '../../../util/Display';
import Const from '../../../util/Constants';

class FieldAddress extends React.Component {
  
  delete = index => {
    const key = this.props.id;
    this.props.onValueChange(key, [ ...this.props.value ].filter((_, i) => i !== index));
  }

  add = () => {
    const key = this.props.id;
    const values = [ ...this.props.value, { } ];
    this.props.onValueChange(key, values);
  }

  onUpdate = (index, field, value) => {
    const addresses = [ ...this.props.value ];
    addresses[index][field] = value;
    this.props.onValueChange(this.props.id, addresses);
  }

  onCitySelected = (city, index) => {
    const key = this.props.id;
    const addresses = [ ...this.props.value ];
    if(city) {
      const state = FieldState.getStateById(city.state_id);
      const country = FieldCountry.getCountryById(state.country_id);
      addresses[index].city = city;
      addresses[index].state = state;
      addresses[index].country = country;
    } else {
      addresses[index].city = null;
      addresses[index].state = null;
      addresses[index].country = null;
    }
    this.props.onValueChange(key, addresses);
  }

  onStateSelected = (state, index) => {
    const key = this.props.id;
    const addresses = [ ...this.props.value ];
    if(state) {
      const country = FieldCountry.getCountryById(state.country_id);
      addresses[index].state = state;
      addresses[index].country = country;
    } else {
      addresses[index].state = null;
      addresses[index].country = null;
    }
    this.props.onValueChange(key, addresses);
  }
  onCountrySelected = (country, index) => {
    const key = this.props.id;
    const addresses = [ ...this.props.value ];
    addresses[index].country = country ? country : null;
    this.props.onValueChange(key, addresses);
  }

  render() {
    const key = this.props.id;
    const visible = this.props.visible;
    const editable = this.props.editable;
    const mandatory = this.props.mandatory;
    const addresses = this.props.value;
    const error = this.props.error;
    const errorMessage = this.props.errorMessage;

    if(!visible || !editable) return null;

    return (
      <>
        <Scroll.Element name={key} />
        { error ? <>&nbsp; : &nbsp; <label className="error-w">{errorMessage}</label></> : null }
        {addresses.map((address, i) =>
          <div key={`${key}_${i + 1}`} className="row row-cols-3 addressdiv col-md-12">
            <div className="col">
              <div className="form-group">
                <label>Address { mandatory ? <span className="required-field"/> : null}</label>
                <FormControl
                  type="text"
                  placeholder="Address"
                  value={address.street}
                  className={`mr-sm-2 ${error ? 'error-w' : ''}`}
                  onChange={event => this.onUpdate(i, Const.Street, event.target.value)}
                  readOnly={!editable} />
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label>City</label>
                <FieldCity
                  index={i}
                  defaultValue={address.city}
                  onCitySelected={this.onCitySelected}
                  isMulti={false} />
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label>State</label>
                <FieldState
                  index={i}
                  defaultValue={address.state}
                  onStateSelected={this.onStateSelected}
                  isMulti={false} />
              </div>
            </div>
            <div className="col">
              <div className="form-group">
                <label>Country</label>
                <FieldCountry
                  index={i}
                  defaultValue={address.country}
                  onSelected={this.onCountrySelected}
                  isMulti={false} />
              </div>
            </div>
            <div className="col ">
              <div className="form-group">
                <label>Pin Code</label>
                <FormControl
                  type="text"
                  placeholder="Pin Code"
                  value={address.pin}
                  className="mr-sm-2"
                  onChange={event => this.onUpdate(i, Const.Pin, event.target.value)}
                  readOnly={!editable} />
              </div>
            </div>
            { Display.MultiAction(i, this.add, this.delete) }
          </div> 
        )}
      </>
    );
  }
}
export default FieldAddress;